import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { TabList, Tab, TabPanel } from '@sumup-oss/circuit-ui';

import { StyledComponentsParams } from 'types/components';

export const ArticleTabs = styled(TabList)(
  ({ theme }: StyledComponentsParams) => css`
    margin-top: ${theme.spacings.tera};
    margin-bottom: ${theme.spacings.mega};
    overflow-y: hidden;
  `,
);

export const TabButton = Tab;

export const TabsContainer = styled.div`
  position: relative;
`;

export const TabContent = styled(TabPanel)(
  ({ theme }: StyledComponentsParams) => css`
    background-color: var(--cui-bg-normal);
    margin-top: ${theme.spacings.giga};
    margin-bottom: ${theme.spacings.mega};
  `,
);
